import { useId } from 'react';
import { coursePartner, courseAudienceLabels, courseAudienceValues, courses, coursesFor } from '../../shared/courses';
import type { CourseAudience } from '../../shared/courses';
import { useBooking } from '../components/BookingProvider';
import { CourseDetails, CourseFacts, CoursePartnerNote } from '../components/CourseCatalog';
import './public.css';

const audienceAnchors: Record<CourseAudience, string> = { kids: 'detyam', adults: 'vzroslym' };

/** «Курсы и лекции»: every partner course with its full programme and a booking button. */
export default function CoursesPage() {
  const { openBooking } = useBooking();
  const id = useId();
  return <>
    <section className="catalog-hero"><div className="container">
      <p className="eyebrow">Вместе со школой «{coursePartner.name}»</p>
      <h1>Курсы и лекции</h1>
      <p className="hero-copy">Дроны, беспилотные системы и нейросети: курсы для детей и подростков и профессиональное обучение для взрослых. Выберите программу и оставьте заявку — свяжемся с вами и обсудим запись.</p>
      <CoursePartnerNote />
      <div className="hero-actions">{courseAudienceValues.map((audience) => <a className="button button--ghost" key={audience} href={`#${audienceAnchors[audience]}`}>{courseAudienceLabels[audience]}</a>)}<a className="courses-partner-site" href={coursePartner.url} target="_blank" rel="noreferrer">Сайт школы: {coursePartner.displayUrl} <span aria-hidden="true">↗</span></a></div>
    </div></section>
    {courseAudienceValues.map((audience) => <section className="section courses-section" id={audienceAnchors[audience]} key={audience} aria-labelledby={`${id}-${audience}`}><div className="container">
      <h2 className="courses-audience" id={`${id}-${audience}`}>{courseAudienceLabels[audience]}</h2>
      <div className="course-list">{coursesFor(audience).map((course) => <article className="course-entry" id={course} key={course} aria-labelledby={`${course}-title`}>
        <div className="course-entry-head">
          <h3 id={`${course}-title`}>{courses[course].title}</h3>
          <p className="course-entry-lead">{courses[course].lead}</p>
          <CourseFacts course={course} />
          <button className="button button--primary" type="button" aria-haspopup="dialog" onClick={() => openBooking(course)}>Записаться на курс</button>
        </div>
        <CourseDetails course={course} level={4} />
      </article>)}</div>
    </div></section>)}
  </>;
}
